<template>
	<b-container id="lists-customer-detail" v-if="$can('view-customer-detail') || $can('view-all')" fluid>
		<b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Customer Detail:</h3>
                        <span style="text-indent: 20px;" v-if="row"><h5>{{ row.name }}</h5></span>
                    </b-col>
                    <b-col class="text-right">
                        <b-button variant="outline-secondary" size="lg" @click="openModal('edit-customer')">Edit</b-button>
                        <b-dropdown id="dropdown-new-transaction" text="New Transaction" variant="success" size="lg" class="m-2" right>
                            <b-dropdown-item v-for="(transactionType, index) in lists.transactionTypes" :key="index" @click="shortcut(transactionType)">{{ transactionType }}</b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-col>
                <b-table-simple hover small responsive bordered>
                    <b-tbody>
                        <b-tr>
                            <b-td><strong>Customer</strong></b-td>
                            <b-td>{{ row.name }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Email</strong></b-td>
                            <b-td>{{ row.email }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Phone</strong></b-td>
                            <b-td>{{ row.phone }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Mobile</strong></b-td>
                            <b-td>{{ row.mobile }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Fax</strong></b-td>
                            <b-td>{{ row.fax }}</b-td>
                        </b-tr>
                        <!-- <b-tr>
                            <b-td><strong>Other</strong></b-td>
                            <b-td></b-td>
                        </b-tr> -->
                        <b-tr>
                            <b-td><strong>Website</strong></b-td>
                            <b-td>{{ row.website }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Notes</strong></b-td>
                            <b-td>{{ row.notes }}</b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col>
                <b-table-simple hover small responsive bordered>
                    <b-tbody>
                        <b-tr>
                            <b-td><strong>Billing Address</strong></b-td>
                            <b-td>
                                <span v-if="row.billing_address_1">{{ row.billing_address_1 }}</span>
                                <span v-if="row.billing_address_2"><br />{{ row.billing_address_2 }}</span>
                                <span v-if="row.billing_city"><br />{{ row.billing_city }}</span>
                                <span v-if="row.billing_state">, {{ row.billing_state }}</span>
                                <span v-if="row.billing_postal_code">{{ row.billing_postal_code }}</span>
                                <span v-if="row.billing_country"><br />{{ row.billing_country }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Shipping Address</strong></b-td>
                            <b-td>
                                <span v-if="row.shipping_address_1">{{ row.shipping_address_1 }}</span>
                                <span v-if="row.shipping_address_2"><br />{{ row.shipping_address_2 }}</span>
                                <span v-if="row.shipping_city"><br />{{ row.shipping_city }}</span>
                                <span v-if="row.shipping_state">, {{ row.shipping_state }}</span>
                                <span v-if="row.shipping_postal_code">{{ row.shipping_postal_code }}</span>
                                <span v-if="row.shipping_country"><br />{{ row.shipping_country }}</span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Terms</strong></b-td>
                            <b-td></b-td>
                        </b-tr>
                        <b-tr>
                            <b-td><strong>Card On File</strong></b-td>
                            <b-td>
                                <b-link v-if="$can('view-customer-detail') || $can('view-all')" @click="openModal('edit-customer') ">{{ preferredPayment('full') }}</b-link>
                                <b-link v-else @click="openModal('edit-customer')">{{ preferredPayment('partial') }}</b-link>
                            </b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><strong>Payment Method</strong></b-td>
                                <b-td>{{ row.payment_method }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td><strong>Delivery Method</strong></b-td>
                                <b-td>{{ row.delivery_method }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
            <b-row>
                <b-container fluid>
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="Transaction List" active>
                            <b-card-text>
                                <b-container fluid>
                                    <b-row class="button-row">
                                        <b-col cols="3">
                                            <b-form-group>
                                                <b-input-group size="sm">
                                                    <b-form-input v-model="tables.transactions.filter" type="search" id="filterInput"
                                                        placeholder="Type to Search" debounce="500">
                                                    </b-form-input>
                                                    <b-input-group-append>
                                                        <b-button :disabled="!tables.transactions.filter" @click="tables.transactions.filter = ''">Clear</b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="3">
                                            <b-form-datepicker v-model="tables.transactions.rowFilters.dateFrom" id="filter-dateFrom" size="sm"
                                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en" today-button
                                                close-button reset-button></b-form-datepicker>
                                        </b-col>
                                        <b-col cols="3">
                                            <b-form-datepicker v-model="tables.transactions.rowFilters.dateTo" id="filter-dateTo" size="sm"
                                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en" today-button
                                                close-button reset-button></b-form-datepicker>
                                        </b-col>
                                        <b-col cols="2">
                                            <treeselect name="typesSelect" class="typesSelect" clearable :searchable="false" open-on-click
                                                clear-on-select close-on-select disableBranchNodes placeholder="Filter by Type"
                                                :options="tables.transactions.types" @input="filterByTypes" />
                                        </b-col>
                                        <b-col cols="1">
                                            <b-form-row>
                                                <!-- <b-col>
                                                    <b-button variant="outline-primary" size="sm" @click="generateExport('pdf')">PDF</b-button>
                                                </b-col> -->
                                                <b-col>
                                                    <b-button variant="outline-primary" size="sm" @click="generateExport('xlsx')">Excel</b-button>
                                                </b-col>
                                            </b-form-row>
                                        </b-col>
                                    </b-row>
                                </b-container>
                                <b-row class="row-transactions-table">
                                    <b-container fluid>
                                        <b-table
                                            :key="tables.transactions.key"
                                            class="transactions-table"
                                            responsive bordered
                                            hover no-border-collapse
                                            sticky-header="600px"
                                            head-variant="light"
                                            :items="filtered" :fields="tables.transactions.fields"
                                            :sort-by="tables.transactions.sortBy"
                                            :sort-desc="tables.transactions.sortDesc"
                                            :per-page="tables.transactions.perPage"
                                            :current-page="tables.transactions.currentPage"
                                            :filter="tables.transactions.filter"
                                            :filterIncludedFields="tables.transactions.filterOn"
                                            @filtered="onFiltered"
                                            :busy="tables.transactions.isBusy"
                                        >

                                            <template v-slot:table-busy>
                                                <div class="text-center text-default my-2">
                                                    <b-spinner class="align-middle"></b-spinner>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </template>

                                            <template v-slot:cell(date)="row">
                                                {{ row.item.date | moment('YYYY-MM-DD')}}
                                            </template>

                                            <template v-slot:cell(id)="row">
                                                <span v-if="row.item.type == 'Invoice'">
                                                    <b-link v-if="canAccessSalesOrder(row.item.sales_rep_name)" :to="{name: 'SalesOrderDetail', params: { soNum: row.item.reference_number } }">{{ row.item.id }}</b-link>
                                                    <span v-else>{{ row.item.id }}</span>
                                                </span>
                                                <span v-else-if="row.item.type == 'Payment'">
                                                    <b-link @click="openModal('edit-payment', row.item)">{{ row.item.id }}</b-link>
                                                </span>
                                                <span v-else-if="row.item.type == 'Credit Memo'">
                                                    <b-link :to="{ name: 'CreditsDetail', params: { creditNum: row.item.id } }">{{ row.item.id }}</b-link>
                                                </span>
                                                <span v-else>{{ row.item.id }}</span>
                                            </template>

                                            <template v-slot:cell(applied_to)="row">
                                                <div v-if="row.item.applied_to_arr && row.item.applied_to_arr.length">
                                                    <span v-for="(apply, index) in row.item.applied_to_arr" :key="index">
                                                        <b-link :to="{name: 'SalesOrderDetail', params: { soNum: apply } }">
                                                            {{ apply }}<br />
                                                        </b-link>
                                                    </span>
                                                </div>
                                            </template>

                                            <template v-slot:cell(amount)="row">
                                                <span v-if="row.item.amount && (row.item.type == 'Invoice' || row.item.type == 'Payment' || row.item.type == 'Credit Memo' || row.item.type == 'Starting Balance')">{{ row.item.amount }}</span>
                                            </template>

                                            <template v-slot:cell(balance)="row">
                                                <span v-if="row.index == 0">
                                                    <b-link @click="openModal('receive-payment', row.item.balance)">{{ row.item.balance.toFixed(2) }}</b-link>
                                                </span>
                                                <span v-else>{{ row.item.balance.toFixed(2) }}</span>
                                            </template>
                                        </b-table>
                                    </b-container>
                                </b-row>

                                <b-row>
                                    <b-col cols="6">
                                        {{ pageTotals }}
                                    </b-col>

                                    <b-col cols="6" class="my-1">
                                        <b-pagination
                                            v-model="tables.transactions.currentPage"
                                            :total-rows="tables.transactions.totalRows"
                                            :per-page="tables.transactions.perPage"
                                            align="fill"
                                            size="sm"
                                            class="my-0"
                                            >
                                        </b-pagination>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab>

                        <!-- <b-tab title="Customer Details">
                            <b-card-text>
                                <b-row>
                                    <b-col>
                                        <b-table-simple hover small responsive bordered>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td><strong>Customer</strong></b-td>
                                                    <b-td>{{ row.name }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Email</strong></b-td>
                                                    <b-td>{{ row.email }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Phone</strong></b-td>
                                                    <b-td>{{ row.phone }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Mobile</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Fax</strong></b-td>
                                                    <b-td>{{ row.fax }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Other</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Website</strong></b-td>
                                                    <b-td>{{ row.website }}</b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Notes</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                    <b-col>
                                        <b-table-simple hover small responsive bordered>
                                            <b-tbody>
                                                <b-tr>
                                                    <b-td><strong>Billing Address</strong></b-td>
                                                    <b-td>
                                                        <span v-if="row.billing_address_1">{{ row.billing_address_1 }}</span>
                                                        <span v-if="row.billing_address_2"><br />{{ row.billing_address_2 }}</span>
                                                        <span v-if="row.billing_city"><br />{{ row.billing_city }}</span>
                                                        <span v-if="row.billing_state">, {{ row.billing_state }}</span>
                                                        <span v-if="row.billing_postal_code">{{ row.billing_postal_code }}</span>
                                                        <span v-if="row.billing_country"><br />{{ row.billing_country }}</span>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Shipping Address</strong></b-td>
                                                    <b-td>
                                                        <span v-if="row.shipping_address_1">{{ row.shipping_address_1 }}</span>
                                                        <span v-if="row.shipping_address_2"><br />{{ row.shipping_address_2 }}</span>
                                                        <span v-if="row.shipping_city"><br />{{ row.shipping_city }}</span>
                                                        <span v-if="row.shipping_state">, {{ row.shipping_state }}</span>
                                                        <span v-if="row.shipping_postal_code">{{ row.shipping_postal_code }}</span>
                                                        <span v-if="row.shipping_country"><br />{{ row.shipping_country }}</span>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Terms</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Payment Method</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td><strong>Delivery Method</strong></b-td>
                                                    <b-td></b-td>
                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-tab> -->
                    </b-tabs>
                </b-card>
            </b-container>
        </b-row>

        <modal-edit-customer
            v-if="modals['edit-customer'].active"
            :row="row"
            @getRow="getRow"
        />

        <modal-receive-payment
            v-if="modals['receive-payment'].active"
            :amount="modals['receive-payment'].amount"
            :customerId="id"
        />

        <modal-edit-payment
            v-if="modals['edit-payment'].active"
            :paymentInfo="modals['edit-payment'].paymentInfo"
            :customerId="id"
        />

        <modal-edit-credit
            v-if="modals['edit-credit'].active"
            :creditInfo="modals['edit-credit'].creditInfo"
            :customerId="id"
        />
	</b-container>
</template>

<script>
    import store from '../../../../store'
    import Treeselect from '@riophae/vue-treeselect'
    import ModalEditCustomer from './modals/EditCustomer'
    import ModalReceivePayment from './modals/ReceivePayment'
    import ModalEditPayment from './modals/EditPayment'
    import ModalEditCredit from './modals/EditCredit'
	export default {
		name: 'CustomerDetail',

        metaInfo() {
            return {
                title: 'Customer - ' + this.row.name,
            }
        },

		props: [ 'id' ],

		components: {
            Treeselect,
            'modal-edit-customer': ModalEditCustomer,
            'modal-receive-payment': ModalReceivePayment,
            'modal-edit-payment': ModalEditPayment,
            'modal-edit-credit': ModalEditCredit
		},

		data() {
            return {
                row: [],

                tables: {
                    transactions: {
                        rowFilters: {

                        },
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'id2',
                        sortDesc: true,
                        filter: null,
                        filterOn: [],
                        key: 1,
                        fields: [
                            {
                                key: 'id',
                                label: 'ID'
                            },
                            {
                                key: 'status',
                                label: 'Status'
                            },
                            {
                                key: 'date',
                                label: 'Date'
                            },
                            {
                                key: 'type',
                                label: 'Type'
                            },
                            {
                                key: 'reference_number',
                                label: 'Reference #'
                            },
                            {
                                key: 'notes',
                                label: 'Notes'
                            },
                            {
                                key: 'applied_to',
                                label: 'Applied To'
                            },
                            {
                                key: 'amount',
                                label: 'Amount'
                            },
                            {
                                key: 'balance',
                                label: 'Balance'
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'customers-table-style-actions'
                            }
                        ],

                        items: [],

                        types: [
                            {
                                id: 'Invoice',
                                label: 'Invoice'
                            },
                            {
                                id: 'Credit Memo',
                                label: 'Credit Memo'
                            },
                            {
                                id: 'Payment',
                                label: 'Payment'
                            }
                        ]
                    }
                },

                lists: {
                    transactionTypes: [
                        'Order',
                        'Payment',
                        'Credit'
                    ]
                },

                modals: {
                    'edit-customer': {
                        active: 0
                    },

                    'receive-payment': {
                        active: 0,
                        amount: 0
                    },

                    'edit-payment': {
                        active: 0,
                        paymentInfo: []
                    },

                    'edit-credit': {
                        active: 0,
                        creditInfo: []
                    }
                }
            }
        },

        methods: {
            canAccessSalesOrder(salesRepName) {
                // If user has view-all permission, they can access all orders
                if (this.$can('view-all')) {
                    return true
                }
                
                // If user has view-sales-order-self permission, they can only access their own orders
                if (this.$can('view-sales-order-self')) {
                    const authName = store.state.auth.user.name
                    // If sales rep name is not available in transaction data, default to allowing access
                    // This prevents breaking the UI when data is incomplete
                    // Note: This assumes the backend API includes sales_rep_name in transaction data
                    return !salesRepName || salesRepName === authName
                }
                
                // Default to false if no permissions match
                return false
            },

            shortcut(area) {
                if (area == 'Order') {
                    this.$router.push({ name: 'SalesOrdersCreate', params: { customerId: this.id } })
                } else if (area == 'Payment') {
                    this.openModal('receive-payment')
                } else if (area == 'Credit') {
                    this.$router.push({ name: 'CreditsCreate', params: { customerId: this.id } })
                }
            },

            generateExport(action, staticButton) {
                if (staticButton) { this.submittingInvoice = 1 }

                let url = 'api/lists/customers/generatetransactionsexport'
                axios.post(url, {
                    customerId: this.id,
                    rows: this.filtered,
                    action: action
                },
                    {
                        responseType: 'blob',
                    })
                    .then((res) => {
                        this.forceFileDownload(res, 'customer_transactions_export_' + this.id + '_', action)
                     }, () => {
                        this.has_error = true
                    })
            },

            forceFileDownload(response, fileName, extension) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName + +new Date() + '.' + extension) //or any other extension
                document.body.appendChild(link)
                link.click()
            },

            filterByTypes(type) {
                this.tables.transactions.items = this.tables.transactions.itemsCopy
                if (type == undefined) {
                    this.tables.transactions.filterOn = []
                } else {
                    this.tables.transactions.items = this.tables.transactions.items.filter(function (itm) {
                        return itm.type == type
                    })
                }

                this.onFiltered(this.tables.transactions.items)
            },

            preferredPayment(show) {
                let cardNumber = ''

                if (this.row.cards_default) {
                    if (show == 'partial') {
                        cardNumber = 'XXXX' + this.row.cards_default.number.substring(this.row.cards_default.number.length - 4)
                    } else {
                        cardNumber = this.row.cards_default.number + ' ' + this.row.cards_default.exp
                    }
                }

                return cardNumber
            },

            openModal(modalName, row, extra) {
                let prefix = 'modal-lists-customers-'
                switch (modalName) {
                    case 'edit-customer':
                        this.modals[modalName].active = 1

                        break

                    case 'receive-payment':
                        this.modals[modalName].active = 1
                        this.modals[modalName].amount = row

                        break

                    case 'edit-payment':
                        this.modals[modalName].active = 1
                        this.modals[modalName].paymentInfo = row

                        break

                    case 'edit-credit':
                        this.modals[modalName].active = 1
                        this.modals[modalName].creditInfo = row

                        break
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            getRow() {
                let url = 'api/lists/customers/getcustomer/' + this.id
                axios.get(url, {})
                .then((res) => {
                    this.row = res.data.customer
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.transactions.totalRows = filteredItems.length
                this.tables.transactions.currentPage = 1
                this.tables.transactions.filteredItems = filteredItems
            },

            getTransactions(silent) {
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/lists/customers/gettransactions/' + this.id
                axios.get(url, {})
                .then((res) => {
                    this.tables.transactions.items = res.data.transactions
                    this.tables.transactions.itemsCopy = res.data.transactions
                    this.tables.transactions.totalRows = this.tables.transactions.items.length

                    if (!silent) {
                        this.toggleBusy()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            toggleBusy() {
                this.tables.transactions.isBusy = !this.tables.transactions.isBusy ? true : false
            }
        },

        computed: {
            pageTotals() {
                let totalRows = this.tables.transactions.totalRows
                let currentPage = this.tables.transactions.currentPage
                let perPage = this.tables.transactions.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.transactions.totalRows + ' rows'
            },

            hasFilters() {
                let hasFilters = false
                let rowFilters = this.tables.transactions.rowFilters
                Object.keys(rowFilters).forEach(key => {
                    if (rowFilters[key].length) {
                        hasFilters = true
                    }
                })

                return hasFilters
            },

            filtered() {
                var items = this.tables.transactions.items
                var rowFilters = this.tables.transactions.rowFilters

                if (items && this.hasFilters) {
                    const filtered = items.filter(item => {
                        return Object.keys(rowFilters).every(key => {
                            if (rowFilters[key].length) {
                                let filterVal = rowFilters[key]

                                if (key == 'active') {
                                    return String(item[key]) == filterVal
                                } else if (key == 'dateFrom') {
                                    return item['date'] >= filterVal
                                } else if (key == 'dateTo') {
                                    return item['date'] <= filterVal
                                } else {
                                    return String(item[key]).toLowerCase().includes(rowFilters[key].toLowerCase())
                                }
                            } else {
                                return true
                            }
                        })
                    })

                    this.tables.transactions.totalRows = filtered.length
                    return filtered
                } else {
                    this.tables.transactions.totalRows = items.length
                    return items
                }
            },
        },

        mounted() {
            this.getRow()
            this.getTransactions()

        	this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-lists-customers-edit-customer':
                        this.modals['edit-customer'].active = 0

                        break

                    case 'modal-lists-customers-receive-payment':
                        this.modals['receive-payment'].active = 0
                        this.modals['receive-payment'].amount = 0

                        break

                    case 'modal-lists-customers-edit-payment':
                        this.modals['edit-payment'].active = 0
                        this.modals['edit-payment'].paymentInfo = []

                        break

                    case 'modal-lists-customers-edit-credit':
                        this.modals['edit-credit'].active = 0
                        this.modals['edit-credit'].creditInfo = []

                        break
                }
            })
        }
	}
</script>

<style lang="scss">
    #lists-customer-detail {
        .vue-treeselect__control {
            font-size: 0.875rem !important;
            height: 31px;

            .vue-treeselect__placeholder {
                line-height: 29px;
            }
        }

        .button-row {
            margin-top: 1rem;
            margin-bottom: 0;
        }
	}
</style>
